import { SofiaEnvironment } from "@/sofia-environment"

export const autoForwardingMockTime = async () => {
  if (SofiaEnvironment.Bff.IsDevelopment && SofiaEnvironment.TimeAtStartup) {
    const MockDate = await import("mockdate")
    let currentTime = new Date(SofiaEnvironment.TimeAtStartup)

    MockDate.set(currentTime)
    window.setInterval(() => {
      currentTime = new Date(currentTime.getTime() + 1000)
      MockDate.set(currentTime)
    }, 1000)
  }
}
